import {Component, OnInit} from '@angular/core';
import {StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {PortalService} from '../../services/portal.service';
import {WarmwassercheckAnfrage} from "../anfrage/warmwassercheck.anfrage";
import {WarmwassercheckRequestService} from "../services/request.service";
import {WarmwassercheckConstants} from "../warmwassercheck.constants";

/**
 * Special component for the start page of the chapter "eingabe". Only Textoutputs, no form.
 */
@Component({
    selector: 'app-warmwassercheck-eingabe-start',
    templateUrl: './eingabe.start.component.html',
    standalone: false
})
export class EingabeStartComponent implements OnInit {

  /**
   * current user data
   */
  anfrage: WarmwassercheckAnfrage;

  /**
   * placeholder for portalname in welcome text
   */
  welcomePlaceholder: any = {};

  /**
   * current portalId
   */
  portalId: string;

  /**
   * textkeyprefix for thermostatcheck
   */
  textkeyPrefix: string = "warmwassercheck.eingabe.start";

  /**
   * link to next step
   */
  nextLink: string = "../../warmwassercheck/eingabe/basisdaten/1";

  constructor(protected stepService: StepService, protected router: Router, protected portalService: PortalService,
              protected requestService: WarmwassercheckRequestService) {
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // get the current portalId
    this.portalId = this.portalService.currentPortalId;

    this.anfrage = this.requestService.getAnfrage();

    // init Placeholder
    this.welcomePlaceholder = {
      portalPlaceholder: this.portalService.getConfig('embed.portal.welcometext') ?
        (' ' + this.portalService.getConfig('embed.portal.welcometext')) : ''
    }
  }
}
